var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChequeIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 38,
    viewBox: "0 0 74 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_241_6752)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41537 27.8158H63.4423V1.41537H1.41537V27.8158ZM63.7873 29.2324H1.07031C0.480669 29.2324 0 28.753 0 28.1633V1.07031C0 0.480669 0.480669 0 1.07031 0H63.7873C64.377 0 64.8576 0.480669 64.8576 1.07031V28.1633C64.8576 28.753 64.377 29.2324 63.7873 29.2324Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.1493 11.1263H0.70708C0.316006 11.1263 0 10.8091 0 10.4192C0 10.0282 0.316006 9.71094 0.70708 9.71094H64.1493C64.5404 9.71094 64.8576 10.0282 64.8576 10.4192C64.8576 10.8091 64.5404 11.1263 64.1493 11.1263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4276 6.51594H59.6514V4.61264H46.4276V6.51594ZM60.3597 7.93252H45.7193C45.3282 7.93252 45.011 7.6153 45.011 7.22423V3.90556C45.011 3.51448 45.3282 3.19727 45.7193 3.19727H60.3597C60.7496 3.19727 61.0668 3.51448 61.0668 3.90556V7.22423C61.0668 7.61409 60.7496 7.93252 60.3597 7.93252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4662 16.4095H4.62652C4.23545 16.4095 3.92065 16.0923 3.92065 15.7024C3.92065 15.3114 4.23545 14.9941 4.62652 14.9941H27.4662C27.8572 14.9941 28.1745 15.3114 28.1745 15.7024C28.1745 16.0923 27.8572 16.4095 27.4662 16.4095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4662 22.0699H4.62652C4.23545 22.0699 3.92065 21.7527 3.92065 21.3616C3.92065 20.9705 4.23545 20.6545 4.62652 20.6545L27.4662 20.6533C27.8572 20.6533 28.1745 20.9705 28.1745 21.3616C28.1745 21.7527 27.8572 22.0699 27.4662 22.0699Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9907 16.4095H42.2522C41.8612 16.4095 41.5439 16.0923 41.5439 15.7024C41.5439 15.3114 41.8612 14.9941 42.2522 14.9941H56.9907C57.3818 14.9941 57.699 15.3114 57.699 15.7024C57.699 16.0923 57.3818 16.4095 56.9907 16.4095Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0461 6.27303H4.62627C4.2352 6.27303 3.91919 5.95581 3.91919 5.56474C3.91919 5.17366 4.2352 4.85645 4.62627 4.85645H16.0461C16.4372 4.85645 16.7544 5.17366 16.7544 5.56474C16.7544 5.95581 16.4372 6.27303 16.0461 6.27303Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.787 25.6046C46.6793 25.6046 46.5727 25.5913 46.465 25.5647C45.4068 25.2947 44.9564 23.8345 44.9612 20.6805C44.9624 20.2894 45.2784 19.9746 45.6683 19.9746H45.6707C46.0618 19.9746 46.3778 20.293 46.3766 20.6841C46.373 23.2763 46.7047 23.9919 46.8234 24.165C47.0304 24.0645 47.7835 23.5233 49.3405 20.6381C49.4894 20.3633 49.8006 20.2192 50.1057 20.2809C50.4108 20.3439 50.6397 20.5994 50.6687 20.9105C50.7862 22.1867 51.3346 23.1201 52.3408 23.7473C53.1096 22.5826 53.9256 21.9845 54.8264 21.9263C55.7684 21.8622 56.6874 22.4179 57.5579 23.5754C57.7928 23.8878 57.7286 24.3309 57.4162 24.5658C57.1039 24.8019 56.6607 24.7389 56.4246 24.4253C56.0372 23.9096 55.4633 23.303 54.9209 23.3393C54.416 23.3708 53.8106 23.9725 53.2161 25.0307C53.0369 25.3504 52.6434 25.4811 52.3081 25.3286C51.0731 24.7728 50.2062 23.941 49.7122 22.8417C48.539 24.7583 47.6346 25.6046 46.787 25.6046Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.41553 9.71186H63.4424V1.41699H1.41553V9.71186ZM45.0111 7.22497V3.9063C45.0111 3.51523 45.3283 3.19801 45.7194 3.19801H60.3586C60.7497 3.19801 61.0669 3.51523 61.0669 3.9063V7.22497C61.0669 7.61484 60.7497 7.93327 60.3586 7.93327H45.7194C45.3283 7.93327 45.0111 7.61605 45.0111 7.22497ZM16.0463 6.27332H4.62644C4.23537 6.27332 3.91936 5.95611 3.91936 5.56503C3.91936 5.17396 4.23537 4.85674 4.62644 4.85674H16.0463C16.4373 4.85674 16.7546 5.17396 16.7546 5.56503C16.7546 5.95611 16.4373 6.27332 16.0463 6.27332Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4652 25.5623C45.4058 25.2923 44.9566 23.8321 44.9603 20.6781C44.9627 20.287 45.2775 19.9722 45.6686 19.9722H45.6698C46.0608 19.9722 46.3781 20.2906 46.3769 20.6817C46.372 23.2739 46.7038 23.9895 46.8236 24.1626C47.0307 24.0621 47.7837 23.5209 49.3408 20.6357C49.4897 20.3609 49.8009 20.2168 50.106 20.2785C50.4111 20.3415 50.6399 20.597 50.669 20.9081C50.7864 22.1843 51.3349 23.1177 52.341 23.7449C53.1086 22.5802 53.9259 21.9821 54.8255 21.9239C55.7687 21.8598 56.6876 22.4155 57.5582 23.573C57.7918 23.8854 57.7289 24.3297 57.4165 24.5634C57.1041 24.7995 56.661 24.7365 56.4249 24.4229C56.0374 23.9072 55.4636 23.3006 54.9199 23.3369C54.4162 23.3684 53.8109 23.9701 53.2164 25.0283C53.0372 25.348 52.6425 25.4787 52.3083 25.3262C51.0734 24.7704 50.2065 23.9386 49.7125 22.8393C48.5393 24.7559 47.6348 25.6022 46.7873 25.6022C46.6795 25.6022 46.573 25.5889 46.4652 25.5623ZM1.41553 27.8143H63.4412V11.124H1.41553V27.8143ZM56.9915 16.4078H42.253C41.8619 16.4078 41.5447 16.0905 41.5447 15.6995C41.5447 15.3096 41.8619 14.9924 42.253 14.9924H56.9915C57.3826 14.9924 57.6998 15.3096 57.6998 15.6995C57.6998 16.0905 57.3826 16.4078 56.9915 16.4078ZM4.62644 20.6539L27.4661 20.6527C27.8572 20.6527 28.1744 20.9711 28.1744 21.3609C28.1744 21.752 27.8572 22.0692 27.4661 22.0692H4.62644C4.23537 22.0692 3.92058 21.752 3.92058 21.3609C3.92058 20.9699 4.23537 20.6539 4.62644 20.6539ZM27.4661 16.4078H4.62644C4.23537 16.4078 3.92058 16.0905 3.92058 15.6995C3.92058 15.3096 4.23537 14.9924 4.62644 14.9924H27.4661C27.8572 14.9924 28.1744 15.3096 28.1744 15.6995C28.1744 16.0905 27.8572 16.4078 27.4661 16.4078Z",
    fill: "#502BAC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4277 4.61035H59.6516V6.51366H46.4277V4.61035Z",
    fill: "#E57373"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_241_6752",
    x: 0,
    y: 0,
    width: 73.8577,
    height: 37.2324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_241_6752"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_241_6752",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChequeIco);
export default __webpack_public_path__ + "static/media/chequeIco.ee284168d33d7f2b02715d5d3aad9646.svg";
export { ForwardRef as ReactComponent };